module.exports = __webpack_public_path__ + "img/mago.f44d4cec.jpg";